import * as actionTypes from "../actionTypes";
import * as tileNames from "../enums/tileNames";
import createReducer from "../lib/createReducer";

export const defaultState = {};

function TILE_ADD(state, action) {
	const {
		__id,
		config,
		controls,
		data,
		detail,
		id,
		legend,
		fakedata,
		name,
		question,
		search,
		showdetailtext,
		title,
	} = action;
	if (!id || !data || !__id) {
		return state;
	}

	return {
		...state,
		[__id]: {
			__id,
			config,
			controls,
			data,
			detail,
			id,
			legend,
			name,
			fakedata,
			question,
			search,
			showdetailtext,
			title,
			loaded: name !== tileNames.GRID,
		},
	};
}

function TILE_ADD_MULTIPLE(state, action) {
	const { tiles } = action;
	if (!tiles || !tiles.length) {
		return state;
	}

	let nextState = state;
	tiles.forEach(tile => {
		nextState = TILE_ADD(nextState, tile);
	});

	return nextState;
}

function TILE_REMOVE_MULTIPLE(state, action) {
	const { tileIds } = action;
	if (!tileIds || !tileIds.length) {
		return state;
	}

	const nextState = { ...state };
	tileIds.forEach(tileId => {
		delete nextState[tileId];
	});

	return nextState;
}

function TILE_SET_LOADED(state, action) {
	const { tileId, loaded } = action;
	if (!tileId) {
		return state;
	}

	return {
		...state,
		[tileId]: {
			...state[tileId],
			loaded,
		},
	};
}

const handlers = {};
handlers[actionTypes.TILE_ADD] = TILE_ADD;
handlers[actionTypes.TILE_ADD_MULTIPLE] = TILE_ADD_MULTIPLE;
handlers[actionTypes.TILE_REMOVE_MULTIPLE] = TILE_REMOVE_MULTIPLE;
handlers[actionTypes.BINDER_TABS_REMOVE] = TILE_REMOVE_MULTIPLE;
handlers[actionTypes.BINDERS_REMOVE] = TILE_REMOVE_MULTIPLE;
handlers[actionTypes.TILE_SET_LOADED] = TILE_SET_LOADED;
export default createReducer(defaultState, handlers);
